import CnLayoutPagePrototypeView from './cn-layout-page/prototypeView';
import CnLayoutCellPrototypeView from './cn-layout-cell/prototypeView';
import CnLayoutHeaderPrototypeView from './cn-layout-header/prototypeView';
import CnLayoutContentPrototypeView from './cn-layout-content/prototypeView';
import CnLayoutSectionPrototypeView from './cn-layout-section/prototypeView';
import CnLayoutRowPrototypeView from './cn-layout-row/prototypeView';
import CnLayoutColPrototypeView from './cn-layout-col/prototypeView';
import CnLayoutAsidePrototypeView from './cn-layout-aside/prototypeView';
import CnLayoutBlockPrototypeView from './cn-layout-block/prototypeView';
import './prototypeView.scss';
const bundle = [
    CnLayoutPagePrototypeView,
    CnLayoutCellPrototypeView,
    CnLayoutHeaderPrototypeView,
    CnLayoutContentPrototypeView,
    CnLayoutSectionPrototypeView,
    CnLayoutRowPrototypeView,
    CnLayoutColPrototypeView,
    CnLayoutAsidePrototypeView,
    CnLayoutBlockPrototypeView,
];
export default bundle;
